import { SafeResourceUrl } from '@angular/platform-browser';

export type ChatVariant = 'arena' | 'freshchat';

/** What the chat host renders: exactly one surface, or nothing. */
export type ChatState =
  | { kind: 'none' }
  | { kind: 'launcher' }
  | { kind: 'selector' }
  | { kind: 'resolving' }
  | { kind: 'arena'; url: SafeResourceUrl }
  | { kind: 'freshchat'; opened: boolean };

/**
 * ARENA only when the experiment explicitly validates and the widget URL exists;
 * every other outcome (false, error, malformed answer, missing token) keeps Freshchat.
 */
export function toChatVariant(validation: unknown, arenaUrl: SafeResourceUrl | null): ChatVariant {
  return validation === true && arenaUrl ? 'arena' : 'freshchat';
}
